export default __webpack_public_path__ + "static/media/amazonpay.5969af4b.webp";